import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { useTranslation } from 'react-i18next';
import styles from './datefilter.module.scss';

/** Formats date as YYYY-MM-DD */
function formatDate(date) {
  const isoString = new Date(date).toISOString();
  const tPos = isoString.indexOf('T');
  const sliced = isoString.slice(0, tPos);
  return sliced;
}

function TableDateFilter({ dateFrom, onDateFromChange, dateTo, onDateToChange }) {
  const { t } = useTranslation();

  const disabledDays = { after: new Date() };

  return (
    <div className={styles.datePickerContainer}>
      <DayPickerInput
        value={dateFrom}
        placeholder={t('common_from')}
        format="YYYY-MM-DD"
        formatDate={formatDate}
        component={DateInput}
        dayPickerProps={{
          selectedDays: [dateFrom, { from: dateFrom, to: dateTo }],
          disabledDays: [{ after: dateTo }, disabledDays],
          toMonth: dateTo,
          numberOfMonths: 1,
          navbarElement: DayPickerNav
        }}
        onDayChange={onDateFromChange}
      />
      <div className={styles.dash}> - </div>
      <DayPickerInput
        value={dateTo}
        formatDate={formatDate}
        placeholder={t('common_to')}
        format="YYYY-MM-DD"
        component={DateInput}
        dayPickerProps={{
          selectedDays: [dateFrom, { from: dateFrom, to: dateTo }],
          disabledDays: [{ before: dateFrom }, disabledDays],
          month: dateFrom,
          fromMonth: dateFrom,
          numberOfMonths: 1,
          navbarElement: DayPickerNav
        }}
        onDayChange={onDateToChange}
      />
    </div>
  );
}

TableDateFilter.propTypes = {
  dateFrom: PropTypes.instanceOf(Date),
  onDateFromChange: PropTypes.func.isRequired,
  dateTo: PropTypes.instanceOf(Date),
  onDateToChange: PropTypes.func.isRequired
};

TableDateFilter.defaultProps = {
  dateFrom: null,
  dateTo: null
};

const DateInput = React.forwardRef((props, ref) => {
  return <input className={styles.dateInput} {...props} ref={ref} />;
});

DateInput.displayName = 'DateInput';

function DayPickerNav({ onPreviousClick, onNextClick }) {
  const stubCallback = () => {};
  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={classnames([styles.navButton, styles.navButtonPrev])}
        type="button"
        title="Previous Month"
        onClick={() => {
          onPreviousClick(stubCallback);
        }}
      />
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={classnames([styles.navButton, styles.navButtonNext])}
        type="button"
        title="Next Month"
        onClick={() => {
          onNextClick(stubCallback);
        }}
      />
    </>
  );
}

DayPickerNav.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired
};

export default TableDateFilter;
